import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { api } from '/app/plugins/services';
import { computed, toValue } from 'vue';
import { useData, usePageContext } from '/app/composables/data';
import { fromPlatformResponse } from '/app/lib/platform';

export const usePlatform = (slug) => {
    const ssrPlatform = usePageContext().platform;

    return useQuery({
        queryKey: ['platform:by-slug', slug],
        queryFn: async () => {
            const { data: response } = await api.platform.find(toValue(slug));

            return fromPlatformResponse(response);
        },
        enabled: computed(() => !!toValue(slug)),
        refetchInterval: 0,
        initialData: () => {
            const target = toValue(slug)?.toLowerCase();

            return target && ssrPlatform?.slug?.toLowerCase() === target ? ssrPlatform : undefined;
        },
    });
}

export const usePlatformLandingPage = (platformSlug, pageSlug) => {
    const pageData = useData()
    const queryClient = useQueryClient();

    const { ...passthrough } = useQuery({
        queryKey: ['platform:page', platformSlug, pageSlug],
        queryFn: async () => {
            const { data: response } = await api.platform.getPage(toValue(platformSlug), toValue(pageSlug));

            return response?.data ?? null;
        },
        enabled: computed(() => !!toValue(platformSlug) && !!toValue(pageSlug)),
        initialData: pageData?.id ? pageData : undefined,
    });

    return {
        ...passthrough,
        optimistic (data) {
            queryClient.setQueryData(['platform:page', platformSlug, pageSlug], () => {
                return data;
            });
        }
    }
}

